import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Loader from "../../components/Loader";
import BackButtonComponent from "../../components/backButton";
import { toast } from "react-toastify";
import { autocloseTiming } from "../../api/regex";
import { postData, cakePhpURL } from "../../api";
import { Button, Modal } from "react-bootstrap";
import "./style.scss";

const Iframe = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type");
  const from = queryParams.get("from");
  const { selectedEmployee } = location.state || {};

  const [, setLoading] = useState(false);
  const [isIframeLoading, setIsIframeLoading] = useState(true);
  const [userid, setUserid] = useState(0);
  const [flowUrl, setFlowUrl] = useState(null);
  const [warningModal, setWarningModal] = useState({
    visible: false,
    message: "",
  });

  const handleIframeLoad = () => {
    setIsIframeLoading(false);
  };
  const [apiCallsInProgress, setApiCallsInProgress] = useState(0);

  const handleApiStart = () => {
    setApiCallsInProgress((prev) => prev + 1);
    setLoading(true);
  };

  const handleApiEnd = () => {
    setApiCallsInProgress((prev) => {
      const newCount = prev - 1;
      if (newCount === 0) {
        setLoading(false);
      }
      return newCount;
    });
  };
  const handleGetUserInfo = async () => {
    handleApiStart();
    const res = await postData("get_user_details", {}, {});
    try {
      if (res?.status === true) {
        setLoading(false);
        setUserid(res.data.user_id);
      } else {
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    } finally {
      handleApiEnd();
    }
  };
  const handleCreateFlow = async () => {
    handleApiStart();
    const payLoadData = {
      user_id: parseInt(userid),
      flow_type: type,
      ...(type === "deductions" && {
        gusto_emp_uuid: selectedEmployee?.gusto_emp_uuid || "",
      }),
    };
    try {
      const res = await postData("createFlow", {}, payLoadData);
      if (res.status === true) {
        setFlowUrl(res.url);
        handleApiEnd();
      } else if (res.message === "Company onboarding is pending") {
        setWarningModal({
          visible: true,
          message: res.message,
        });
        handleApiEnd();
      } else {
        toast.error(res.message, {
          theme: "colored",
          autoClose: autocloseTiming,
        });
        handleApiEnd();
      }
    } catch (err) {
      toast.error(err, {
        theme: "colored",
        autoClose: autocloseTiming,
      });
      handleApiEnd();
    }
  };

  useEffect(() => {
    handleGetUserInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (userid !== 0) {
      handleCreateFlow();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userid]);

  const getRedirectPath = (from, selectedEmployee) => {
    switch (from) {
      case "profile":
        return `/profile/${selectedEmployee?.userId}`;
      case "employee-list":
        return `/employee-deduction-list`;
      default:
        return new URL("clients/payroll", cakePhpURL).href;
    }
  };
  const handleRedirection = () => {
    window.history.go(-1);
  };
  const typeCapitalized = type?.charAt(0).toUpperCase() + type?.slice(1);
  return (
    <>
      {apiCallsInProgress > 0 ? (
        <Loader />
      ) : (
        <div className="mx-3">
          <div className="mt-3 mb-2">
            <BackButtonComponent
              reDirectionpath={getRedirectPath(from, selectedEmployee)}
            />
          </div>
          <div className="emp-state-tax-view">
            {isIframeLoading && (
              <div className="emp-iframe-loading">
                <Loader />
              </div>
            )}
            <iframe
              src={flowUrl}
              name="emp-state-tax-view"
              height="100%"
              width="100%"
              title="Iframe Example"
              onLoad={handleIframeLoad}
            ></iframe>
          </div>
        </div>
      )}
      <Modal
        show={warningModal.visible}
        backdrop="static"
        keyboard={false}
        className="warning-non-close-modal"
      >
        <Modal.Header>Finish Company Onboarding</Modal.Header>
        <Modal.Body>
          You’ll be able to set up {typeCapitalized} once your company
          onboarding is complete. Please complete the onboarding process to
          continue.
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={handleRedirection}
            className="modal-btn-wrapper modal-email-footer-button"
          >
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Iframe;
